import $ from 'jquery'

import form from '../../edit/form/form'

import documentInsert from '../../lib/documentInsert'
import documentUpdate from '../../lib/documentUpdate'
import documentRemove from '../../lib/documentRemove'
import generateThumbAntiArchive from '../../lib/generateThumbAntiArchive'
import generateSnippet from '../../lib/generateSnippet'

import * as timecode from '../../../../lib/timecode'

export function getName(){
  return 'anti-archive/marker'
}

export function getTableColumns(o,item){

  var lang = o.store('lang')

  var columns = [
    {
      id: 'roll',
      value: item.roll,
      type: o.type.text,
    },
    {
      id: 'start',
      value: item.start,
      type: o.type.timecode,
    },
    {
      id: 'tag',
      value: _.find(o.data.antiArchive.tags,{_id: item.tag})[lang],
      type: o.type.text,
    },
    {
      id: 'notes',
      value: item.notes,
      type: o.type.textLong,
      width: 200,
      multiline: true,
      auth: ['admin','author'],
    },
    {
      id: 'filter',
      value: item.filter,
      type: o.type.filter,
      width: 70,
    },
    {
      id: 'public',
      value: item.public,
      type: o.type.toggle,
      auth: ['admin','author'],
      width: 70,
    },
    {
      id: 'tagPublic',
      value: _.find(o.data.antiArchive.tags,{_id: item.tag}).public,
      type: o.type.toggle,
      auth: ['admin','author'],
      width: 70,
    },
    {
      id: 'inFullSequence',
      value: item.inFullSequence,
      type: o.type.toggle,
      width: 70,
    },
    {
      id: 'user',
      value: item.user,
      type: o.type.text,
      auth: ['admin','author'],
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
      auth: ['admin','author'],
    },
  ]

  return columns

}

export function getTableData(o){

  var data =
    _.map(

      o.data.antiArchive.markers,

      function(item){

        var model = o.model.aaMarkers
        var columns = model.getTableColumns(o,item)

        var click =
          function(){
            var roll = _.find(o.data.rolls, {roll: item.roll})
            var start = timecode.toSeconds(item.start)
            var brightness = item.brightness
            o.player.load(roll,start,brightness)
            o.edit.set(item,model)
          }

        return {
          columns: columns,
          click: click,
        }

      }
    )

  return data

}

export function getFormFields(o,item){

  var lang = o.store('lang')

  if(!item){
    var item = {}
  }

  if(o.loopStart){
    var start = timecode.toSmtp(o.loopStart)
  } else {
    var start = timecode.toSmtp(0)
  }

  var init = {
    roll: o.roll,
    start: start,
    public: false,
  }

  var fields = [
    {
      id: 'roll',
      value: item.roll,
      type: 'text',
      init: init.roll,
    },
    {
      id: 'start',
      value: item.start,
      type: 'timecode',
      edit: true,
      init: init.start,
    },
    {
      id: 'tag',
      value: item.tag ? _.find(o.data.antiArchive.tags,{_id: item.tag})[lang] : null,
      type: 'text',
      options: _.map(o.data.antiArchive.tags, lang),
      optionsModel: o.model.aaTags,
      edit: true,
    },
    {
      id: 'filter',
      value: item.filter,
      type: 'filter',
      edit: true,
      optional: true,
    },
    {
      id: 'notes',
      value: item.notes,
      type: 'textLong',
      optional: true,
      edit: true,
    },
    {
      id: 'public',
      value: item.public,
      type: 'toggle',
      edit: true,
      init: init.public,
    },
    {
      id: 'inFullSequence',
      value: item.inFullSequence,
      type: 'toggle',
      edit: true,
      init: init.inFullSequence,
    },
  ]

  return fields

}

export function insertForm(o,done){

}

export function remove(o,id,done){

  var data = o.data.antiArchive.markers
  var collection = 'aa_markers'

  documentRemove(o,data,id,collection,done)

}

export function insert(o,item,done){

  var lang = o.store('lang')

  var data = o.data.antiArchive.markers
  var collection = 'aa_markers'

  if(item.tag){
    var tag = _.find(o.data.antiArchive.tags,{[lang]: item.tag})
    if(tag){
      item.tag = tag._id
    }
  }

  var d = function(error,item){
    o.player.updateMarkers()
    done(error,item)
  }

  item.user = o.store('email')
  item.date = new Date()

  documentInsert(o,data,item,collection,d)
  generateThumbAntiArchive(item.roll,item.start,null,item.filter)

}

export function update(o,id,changes,done){

  var lang = o.store('lang')

  var data = o.data.antiArchive.markers
  var collection = 'aa_markers'

  var startChange = _.find(changes,{id: 'start'})
  var filterChange = _.find(changes,{id: 'filter'})

  if(startChange || filterChange){

    var marker = _.find(data,{_id: id})
    var roll = marker.roll
    var filter = marker.filter

    if(startChange){
      var start = startChange.value
      var deleteStart = marker.start
    } else {
      var start = marker.start
      var deleteStart = undefined
    }

    generateThumbAntiArchive(roll,start,deleteStart,filter)

  }

  var tagChange = _.find(changes,{id: 'tag'})

  if(tagChange){
    var value = tagChange.value
    var tag = _.find(o.data.antiArchive.tags,{[lang]: value})
    if(tag){
      tagChange.value = tag._id
    }
  }

  changes.push({
    id: 'user',
    value: o.store('email'),
  })

  changes.push({
    id: 'date',
    value: new Date(),
  })

  documentUpdate(o,data,id,changes,collection,done)

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/aaMarkers/aaMarkers.js